import React from 'react'
import PropTypes from 'prop-types'
import { compose, links, string } from 'common/helpers'
import { injectIntl } from 'sb-react-intl'

import ImageWithPlaceholderFallback from 'components/ui/ImageWithPlaceholderFallback/ImageWithPlaceholderFallback'
import Message from 'components/text/Message/Message'
import Link from 'components/ui/Link/Link'

import messages from './messages.js'
import s from './BrandResult.scss'


const BrandResult = ({ index, brand: { name, img }, brand, onClick, intl }) => {
  const safeName = string.trimHtml(name)
  const url = links.brand.replace(':name', safeName.toLowerCase())

  return (
    <Link
      className={s.link}
      to={url}
      onClick={() => onClick({ brand: { ...brand, name: safeName }, position: index + 1 })}
      blackToBrandColor
      aria-label={intl.formatMessage(messages.goTo, { brand: `${safeName}` })}
    >
      <ImageWithPlaceholderFallback
        className={s.image}
        src={img}
        w={100}
        role="presentation"
      />
      <Message tag="div" className={s.name} text={name} html />
    </Link>
  )
}

BrandResult.propTypes = {
  index: PropTypes.number,
  brand: PropTypes.shape({
    name: PropTypes.string.isRequired,
    img: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,

  intl: PropTypes.object, // @injectIntl
}


export default compose(
  injectIntl,
)(BrandResult)
